import { useMemo } from 'react';
import { computeAchievements, computePoints, levelFor, qualityMultiplier, scrapRate } from './gamification';
import type { WorkProfileStats } from './types';

/** Points, level, badges and quality multiplier derived from a stats row. */
export function useGamification(stats: WorkProfileStats | undefined | null) {
  return useMemo(() => {
    if (!stats) return null;
    const points = computePoints(stats);
    return {
      points,
      level: levelFor(points),
      achievements: computeAchievements(stats),
      multiplier: qualityMultiplier(stats),
      scrapRate: scrapRate(stats.units_total, stats.scrap_total),
    };
  }, [stats]);
}
